import React, { createContext } from "react";

const ModalContext = createContext<boolean>(false);

export const ModalContextProvider: React.FC<React.PropsWithChildren<{ inModal?: boolean }>> = ({
  children,
  inModal = true,
}) => {
  return <ModalContext.Provider value={inModal}>{children}</ModalContext.Provider>;
};

export default ModalContext;
